// extracted by mini-css-extract-plugin
export default {"carouselWrapper":"Carousel__carouselWrapper--2Va","carouselContainer":"Carousel__carouselContainer--1I1","itemWithNumeration":"Carousel__itemWithNumeration--2UZ"};